export default __webpack_public_path__ + "static/media/Hero.164814e6.png";